import { computed, ref, nextTick } from "vue";
import { useStore } from 'vuex';
import Helpers from "../../helpers";

// Une nombres y apellidos; algunos usuarios tienen el nombre completo solo en primer_nombre
export const fullName = (u) => {
    if (!u) return "";
    return [u.primer_nombre, u.segundo_nombre, u.primer_apellido, u.segundo_apellido]
        .map(p => (p || "").toString().trim())
        .filter(Boolean)
        .join(" ");
};

export function useMembership() {
    const store = useStore();

    // Estado reactivo manteniendo compatibilidad con el template
    const modalActive = ref(false);
    const modalActiveForm = ref(false);
    const modalActiveCredential = ref(false);

    const nameAgent = ref(null);
    const email = ref(null);
    const role = ref(null);
    const membership = ref(null);
    const userId = ref(null);
    const cedula = ref(null);
    const isLoading = ref(false);
    const spinner = ref(true);
    const alertTable = ref({
        state: false,
        message: ""
    });

    const credentialMercadolibreForm = ref({
        userId: null,
        credentialId: null
    })


    const userdata = ref(null);
    const empresaData = ref(null);

    // Child users modal state
    const modalActiveChildren = ref(false);
    const childUsers = ref({ data: [], current_page: 1, last_page: 1, per_page: 15, total: 0 });
    const childParentUser = ref(null);
    const childFilters = ref({ email: null, nameAgent: null, role: null });
    const spinnerChildren = ref(false);

    // Constantes para timeouts
    const ALERT_TIMEOUT = 5000;
    const SUCCESS_ALERT_TIMEOUT = 1000;

    /**
     * Maneja errores de manera consistente
     * @param {Error} error - Error capturado
     * @param {string} defaultMessage - Mensaje por defecto
     */
    const handleError = (error, defaultMessage = "Ha ocurrido un error") => {
        console.error('Error:', error);
        showAlert(error?.message || defaultMessage);
    };

    /**
     * Muestra alertas con timeout automático
     * @param {string} message - Mensaje a mostrar
     * @param {number} timeout - Tiempo en ms para ocultar la alerta
     */
    const showAlert = (message, timeout = ALERT_TIMEOUT) => {
        alertTable.value.state = true;
        alertTable.value.message = message;

        setTimeout(() => {
            alertTable.value.state = false;
            alertTable.value.message = "";
        }, timeout);
    };

    /**
     * Ejecuta dispatch con manejo de errores consistente
     * @param {string} action - Acción de Vuex
     * @param {any} payload - Datos a enviar
     * @returns {Promise}
     */
    const dispatchWithErrorHandling = async (action, payload = null) => {
        try {
            return await store.dispatch(action, payload);
        } catch (error) {
            handleError(error);
            throw error;
        }
    };

    // Métodos para obtener datos auxiliares
    const getStates = async (data) => {
        await dispatchWithErrorHandling('appHelpers/storeStates', data);
    };

    const getCities = async (data) => {
        await dispatchWithErrorHandling('appHelpers/storeCities', data);
    };

    const getZones = async (data) => {
        await dispatchWithErrorHandling('appHelpers/storeZones', data);
    };

    const getHelpers = async () => {
        await dispatchWithErrorHandling('appHelpers/storeHelpers');
    };


    // Métodos para manejo de modales
    const showModalUserdata = (data) => {
        if (!data) {
            console.warn('No se proporcionaron datos para el modal');
            return;
        }
        userdata.value = data.userdata ? { ...data.userdata } : { ...data };
        empresaData.value = data.empresa || null;
        modalActive.value = true;
    };

    const showModalForm = (data = null) => {
        userdata.value = data;
        modalActiveForm.value = true;
    };

    const toggleModal = () => {
        modalActive.value = false;
        userdata.value = null;
    };

    const toggleModalForm = () => {
        modalActiveForm.value = false;
        userdata.value = null;
    };
    const toggleModalCredential = () => {
        modalActiveCredential.value = false;
        userdata.value = null;
    }

    const closeModal = (res) => {
        if (res && typeof res === 'string') {
            showAlert(res, SUCCESS_ALERT_TIMEOUT);
        }
        toggleModalForm();
    };

    const showModalCredential = async (data) => {
        userdata.value = data;
        credentialMercadolibre.value.userId = data.id;
        modalActiveCredential.value = true;
    }

    // Métodos principales de negocio
    const updateCountUser = async (data) => {
        if (!data) {
            handleError(new Error('Datos requeridos para actualizar usuario'));
            return;
        }

        isLoading.value = true;
        try {
            await dispatchWithErrorHandling('appMembership/updateCountUser', data);
            showAlert("Cantidad de usuarios actualizada correctamente", SUCCESS_ALERT_TIMEOUT);
        } finally {
            isLoading.value = false;
        }
    };

    const getMemberships = async (page = 1) => {
        if (page < 1) {
            console.warn('Número de página inválido, usando página 1');
            page = 1;
        }

        const currentFilters = {
            nameAgent: nameAgent.value,
            email: email.value,
            role: role.value,
            membership: membership.value,
            user_id: userId.value,
            cedula: cedula.value
        };

        console.log("Filtros aplicados en página", page, ":", currentFilters);

        const filterData = Helpers.eliminarNull(currentFilters);

        console.log("Filtros procesados:", filterData);

        try {
            await dispatchWithErrorHandling('appMembership/storeMemberships', {
                filters: filterData,
                page
            });
            spinner.value = false;
        } catch (error) {
            spinner.value = false;
            throw error;
        }
    };

    const exportMembresia = async () => {
        isLoading.value = true;
        try {
            await dispatchWithErrorHandling('appMembership/exportMembresia');
            showAlert("Exportación completada exitosamente", SUCCESS_ALERT_TIMEOUT);
        } finally {
            isLoading.value = false;
        }
    };

    const toggleEstadoUser = async (data) => {
        if (!data || !data.id) {
            handleError(new Error('ID de usuario requerido'));
            return;
        }

        isLoading.value = true;
        try {
            await dispatchWithErrorHandling('appMembership/toggleEstadoUser', data);
            showAlert("Estado actualizado correctamente", SUCCESS_ALERT_TIMEOUT);
        } finally {
            isLoading.value = false;
        }
    };

    const getCredentialMercadolibre = async () => {
        await dispatchWithErrorHandling('appMembership/getCredentialMercadolibre').then(() => {

        })
    };
      const addCredentialMercadolibre = async () => {
         await dispatchWithErrorHandling('appMembership/addCredentialMercadolibre', {
                data:  {
                    user_id: userdata.value.id,
                    credentialId: credentialMercadolibreForm.value.credentialId
                },

            }).then(() => {
                toggleModalCredential()

                getMemberships()
            });
    };


    // Child users methods
    const showModalChildren = (user) => {
        childParentUser.value = user;
        childFilters.value = { email: null, nameAgent: null, role: null };
        getChildUsers(1);
        modalActiveChildren.value = true;
    };

    const toggleModalChildren = () => {
        modalActiveChildren.value = false;
        childParentUser.value = null;
        childUsers.value = { data: [], current_page: 1, last_page: 1, per_page: 15, total: 0 };
    };

    const getChildUsers = async (page = 1) => {
        if (!childParentUser.value) return;
        spinnerChildren.value = true;
        try {
            const filters = Helpers.eliminarNull({
                email: childFilters.value.email,
                nameAgent: childFilters.value.nameAgent,
                role: childFilters.value.role,
                per_page: 15
            });
            const result = await dispatchWithErrorHandling('appMembership/getChildUsers', {
                userId: childParentUser.value.id,
                page,
                filters
            });
            childUsers.value = result;
        } catch (error) {
            console.error('Error fetching child users:', error);
        } finally {
            spinnerChildren.value = false;
        }
    };

    const applyChildFilters = () => {
        getChildUsers(1);
    };

    const childPageChangeHandle = (value) => {
        const currentPage = childUsers.value.current_page || 1;
        let newPage = parseInt(currentPage);
        switch (value) {
            case "next": newPage = currentPage + 1; break;
            case "previous": newPage = Math.max(currentPage - 1, 1); break;
            default: newPage = parseInt(value) || 1; break;
        }
        if (newPage < 1) newPage = 1;
        getChildUsers(newPage);
    };

    const cleanFilter = () => {
        // Limpiar todos los filtros individualmente
        nameAgent.value = null;
        email.value = null;
        membership.value = null;
        role.value = null;
        userId.value = null;
        cedula.value = null;

        // Resetear a página 1 y recargar datos
        store.commit('appMembership/setCurrentPage', 1);

        // Recargar datos después de limpiar filtros
        nextTick(() => {
            getMemberships(1);
        });
    };

    /**
     * Aplica filtros y resetea a la página 1
     * Útil cuando se cambian los filtros desde el template
     */
    const applyFilters = async () => {
        store.commit('appMembership/setCurrentPage', 1);
        await getMemberships(1);
    };

    const pageChangeHandle = async (value) => {
        const currentPage = store.state.appMembership?.currentPage || 1;
        let newPage = parseInt(currentPage);

        switch (value) {
            case "next":
                newPage = currentPage + 1;
                break;
            case "previous":
                newPage = Math.max(currentPage - 1, 1); // No ir por debajo de 1
                break;
            default:
                newPage = parseInt(value) || 1; // Asegurar que sea un número válido
                break;
        }

        // Validar que la página sea válida
        if (newPage < 1) {
            newPage = 1;
        }

        store.commit('appMembership/setCurrentPage', newPage);

        // Aplicar filtros actuales al cambiar de página
        await getMemberships(newPage);
    };

    // Configuración de headers de tabla - constante para mejor rendimiento
    const headers = Object.freeze([
        { field: "id", key: 'id', label: "Código" },
        { field: "estado_user", key: 'Estado', label: "Estado" },
        { field: "primer_nombre", label: "Nombre" },
        { field: "email", key: 'email', label: "Email" },
        { field: "roles_users", key: 'Rol', label: "Rol" },
        { field: "payment_plan_users", key: 'payment_plan_users', label: "Membresía" },
        { field: "permission_count_inmuebles", key: 'D. inmuebles', label: "D. Inmuebles" },
        { field: "permission_count_usuarios", key: 'D. USUARIO', label: "D. Usuarios" },
        { field: "child_users_count", label: "Usuarios Hijos" },
        { field: "inmuebles_count", label: "Inmuebles" },
        { field: 'userdata', key: 'userdata', label: "Info" },
        { field: 'actions', key: 'action', label: "Acciones" },
    ]);

    // Computed properties con validación
    const genres = computed(() => store.state.appHelpers?.genres || []);
    const countries = computed(() => store.state.appHelpers?.countries || []);
    const states = computed(() => store.state.appHelpers?.states || []);
    const zones = computed(() => store.state.appHelpers?.zones || []);
    const cities = computed(() => store.state.appHelpers?.cities || []);
    const documentType = computed(() => store.state.appHelpers?.documentType || []);
    const roles = computed(() => store.state.appHelpers?.roles || []);
    const memberships_plans = computed(() => store.state.appHelpers?.memberships || []);
    const memberships = computed(() => store.state.appMembership?.memberships || []);

    const credentialMercadolibre = computed(() => store.state.appMembership?.credentialMercadolibre || []);


    return {
        // Datos y estado
        headers,
        userdata,
        empresaData,

        // Estado individual para compatibilidad con template
        modalActive,
        modalActiveForm,
        modalActiveCredential,
        spinner,
        isLoading,
        alertTable,

        // Filtros individuales
        role,
        nameAgent,
        email,
        membership,
        userId,
        cedula,

        // Computed properties
        genres,
        countries,
        states,
        cities,
        zones,
        documentType,
        roles,
        memberships_plans,
        memberships,
        showModalCredential,
        getCredentialMercadolibre,
        credentialMercadolibre,
        credentialMercadolibreForm,
        addCredentialMercadolibre,

        // Métodos de datos auxiliares
        getHelpers,
        getStates,
        getCities,
        getZones,


        // Métodos principales
        getMemberships,
        updateCountUser,
        exportMembresia,
        toggleEstadoUser,
        cleanFilter,
        applyFilters,
        pageChangeHandle,

        // Child users
        modalActiveChildren,
        childUsers,
        childParentUser,
        childFilters,
        spinnerChildren,
        showModalChildren,
        toggleModalChildren,
        getChildUsers,
        applyChildFilters,
        childPageChangeHandle,

        // Métodos de interfaz
        showModalUserdata,
        showModalForm,
        toggleModal,
        toggleModalForm,
        toggleModalCredential,
        closeModal,
        showAlert
    };
}
